import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

import { UIIcon } from "../../../../ui";
import { getEventRequirementVisual } from "../../../../../utils/eventRequirementTypes";

import "./EventRequirementNameCell.scss";

const EventRequirementNameCell = ({ name, dir }) => {
  const visual = getEventRequirementVisual(name);

  return (
    <Box className="event-requirement-name-cell" dir={dir}>
      {visual ? (
        <span
          className="event-requirement-name-cell__icon-box"
          style={{ backgroundColor: visual.backgroundColor }}
        >
          <UIIcon
            name={visual.iconName}
            size="sm"
            color={visual.iconColor}
            decorative
          />
        </span>
      ) : null}
      <Typography className="event-requirement-name-cell__label">
        {name}
      </Typography>
    </Box>
  );
};

EventRequirementNameCell.propTypes = {
  name: PropTypes.string,
  dir: PropTypes.oneOf(["ltr", "rtl"]),
};

EventRequirementNameCell.defaultProps = {
  name: "",
  dir: "ltr",
};

export default EventRequirementNameCell;
